import React from 'react';
import { Link } from 'react-router-dom';
import {
  ComputerDesktopIcon,
  ArrowsRightLeftIcon,
  UserGroupIcon,
  ArrowRightIcon,
} from '@heroicons/react/24/outline';

export default function CoverageHub() {
  return (
    <div className="p-8 max-w-4xl mx-auto">

      {/* Page header */}
      <div className="mb-8">
        <h1 className="text-xl font-bold text-gray-100">Coverage Analysis</h1>
        <p className="text-sm text-gray-500 mt-1">
          Inspect device inventory across workloads or compare coverage to find gaps
        </p>
      </div>

      {/* Workspace cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-6">

        {/* Device Inventory card */}
        <Link
          to="/coverage/devices"
          className="bg-gray-900 border border-gray-800 hover:border-blue-500/40 rounded-xl p-6 flex flex-col transition-colors group"
        >
          <div className="flex items-start gap-3 mb-5">
            <div className="p-2.5 bg-blue-600/15 rounded-lg flex-shrink-0">
              <ComputerDesktopIcon className="h-6 w-6 text-blue-400" />
            </div>
            <div className="flex-1">
              <h2 className="text-base font-semibold text-gray-100">Device Inventory</h2>
              <p className="text-xs text-gray-500 mt-0.5">
                Browse devices in M365, DRMM, and BlackPoint Cyber inventory
              </p>
            </div>
          </div>

          <div className="mt-auto flex items-center text-sm font-medium text-blue-400 group-hover:text-blue-300">
            Open
            <ArrowRightIcon className="h-4 w-4 ml-1.5" />
          </div>
        </Link>

        {/* Device Inventory Comparison card */}
        <Link
          to="/coverage/comparison"
          className="bg-gray-900 border border-gray-800 hover:border-purple-500/40 rounded-xl p-6 flex flex-col transition-colors group"
        >
          <div className="flex items-start gap-3 mb-5">
            <div className="p-2.5 bg-purple-600/15 rounded-lg flex-shrink-0">
              <ArrowsRightLeftIcon className="h-6 w-6 text-purple-400" />
            </div>
            <div className="flex-1">
              <h2 className="text-base font-semibold text-gray-100">Device Inventory Comparison</h2>
              <p className="text-xs text-gray-500 mt-0.5">
                Cross-reference devices across workloads to identify coverage gaps
              </p>
            </div>
          </div>

          <div className="mt-auto flex items-center text-sm font-medium text-purple-400 group-hover:text-purple-300">
            Open
            <ArrowRightIcon className="h-4 w-4 ml-1.5" />
          </div>
        </Link>

        {/* Identity Inventory card */}
        <Link
          to="/coverage/entra-identity"
          className="bg-gray-900 border border-gray-800 hover:border-emerald-500/40 rounded-xl p-6 flex flex-col transition-colors group"
        >
          <div className="flex items-start gap-3 mb-5">
            <div className="p-2.5 bg-emerald-600/15 rounded-lg flex-shrink-0">
              <UserGroupIcon className="h-6 w-6 text-emerald-400" />
            </div>
            <div className="flex-1">
              <h2 className="text-base font-semibold text-gray-100">Identity Inventory</h2>
              <p className="text-xs text-gray-500 mt-0.5">
                Browse the daily Entra snapshot of users, groups, directory roles, and role holders
              </p>
            </div>
          </div>

          <div className="mt-auto flex items-center text-sm font-medium text-emerald-400 group-hover:text-emerald-300">
            Open
            <ArrowRightIcon className="h-4 w-4 ml-1.5" />
          </div>
        </Link>
      </div>
    </div>
  );
}
